export const CLASS_NAMES = [
  "I1A1",
  "I1A2",
  "I1B1",
  "I1B2",
  "I2A",
  "I2B1",
  "I2B2",
  "I3A1",
  "I3A2",
  "I3B1",
  "T2IT2",
  "T3IT1",
  "LED1",
  "LED2",
] as const;
export type ClassNameType = (typeof CLASS_NAMES)[number];

export type ClassData = {
  students: string[];
};

export type Classes = Record<ClassNameType, ClassData>;

export const CLASSES: Classes = {
  LED1: {
    students: [
      "nathan",
      "tirza",
      "marit",
      "jennifer",
      "safira",
      "sofie",
      "tugra",
      "jay",
      "sade",
      "elijah",
      "gulnur",
      "robyn",
      "dyar",
      "chris",
      "sander",
      "veronique",
      "joshua",
      "bailey",
      "nikki",
      "faline",
      "sude",
      "bunyan",
      "mats",
      "zusje",
      "natalia",
    ],
  },
  LED2: {
    students: ["caelyn", "righley", "thijmen"],
  },
  I1A1: {
    students: [
      "mitchell",
      "batu",
      "toby",
      "ibrahim",
      "fylison",
      "aliyah",
      "jaimy",
      "semi",
      "suryani",
      "isaiah",
      "rafael",
      "jochem",
      "luca",
      "noud",
      "jimmy",
      "moegtaar",
      "quinten",
    ],
  },
  I1A2: {
    students: [
      "zameer",
      "jayson",
      "suus",
      "collin",
      "matthijs",
      "freek",
      "dylano",
      "wensley",
      "caz",
      "kjell",
      "ody",
      "jason",
      "thomas",
      "renzo",
    ],
  },
  I1B1: {
    students: [
      "deon",
      "siem",
      "milan",
      "mazid",
      // "ashwani",
      "tijmen",
      "berat",
      "luca",
      "timothy",
      "jay",
      "dean",
      // "exequiel",
      "luuk",
      "denzell",
      "manav",
      "niki",
      "tioma",
    ],
  },
  I1B2: {
    students: [
      // "remco",
      // "yaro",
      "gijs",
      "adil",
      "rishay",
      "benjamin",
      "jesse",
      "peter",
      "duran",
      "amar",
      "sverre",
      "jeremy",
      "dani",
      "rochano",
      "levi",
    ],
  },
  I2A: {
    students: [
      "Daris",
      "Levi",
      "Joshua",
      "zane",
      "Zen",
      "Martijn",
      "Luca",
      "sietse",
      "nathaniel",
      "Teun",
      "tiamo",
      "muhammad",
      // "muhammet",
      "damian",
      // "cello",
      "Jay",
      "Demian",
    ],
  },
  I2B1: {
    students: [
      "Kostas",
      // "milo",
      "daan",
      "joel",
      "levi",
      "gijs",
      "joey",
      "killian",
      "jona",
      "rayvano",
      "olav",
      "stefan",
      "jimmy",
    ],
  },
  I2B2: {
    students: [
      "Eljah",
      "Indi",
      "Toby",
      "Darnell",
      "Fabian",
      "Duncan",
      "Jort",
      "Jaimy",
      "Keano",
      "Luc",
      "Kyan",
      "Tygo",
      "Dylan",
    ],
  },
  T2IT2: {
    students: ["yash"],
  },
  I3A1: {
    students: [
      "dalisha",
      "daylin",
      "mark",
      "matti",
      "mauro",
      "richard",
      "riley",
      "shakir",
      "stef",
      "tin",
    ],
  },
  I3A2: {
    students: [
      "andre",
      "boaz",
      "joel",
      "joey",
      "joris",
      "leonard",
      "levent",
      "mathijs",
      "mohammed",
      "thomas",
      "tom",
      "yoran",
    ],
  },
  I3B1: {
    students: [
      "baldr",
      "bram",
      "jayden",
      "joshua",
      "matthieu",
      "merlijn",
      "miguel",
      "numaan",
      "rick",
      "shivan",
      "steph",
      "vygo",
      "yuan",
      "tobias",
    ],
  },
  T3IT1: {
    students: ["luciano"],
  },
};
